import React, { useEffect, useRef, useState } from "react";
import { isMobile } from 'react-device-detect';
import navItems from '../../placesInfo';
import * as BABYLON from 'babylonjs';
import * as AppConstants from '../../AppConstants'

import CustomizedDialogs from './../PopUp/PopUpComponent'

import poiImg from './../../image/Info.png'
import borderImg from './../../image/Border.png'
import { Vector3 } from "babylonjs";
import * as querystring from 'query-string'

var currentscene: any;
declare global {
    interface Window
    {
        POIHelper: any;
        POIHelperAngle: Number;
        POIHelperHeight: Number;
        Camera: BABYLON.ArcRotateCamera;
    }
  }
      // TODO stronglytype the item, stop doing javascript
      const calculateSphereItemPosition = function(item: any) {
        const radiusPositionSphere = 400;
        console.log("====>" + Math.sin(item.coords.angle));
        return new BABYLON.Vector3(Math.sin(item.coords.angle)*radiusPositionSphere, item.coords.height, Math.cos(item.coords.angle)*radiusPositionSphere);
    }
function MovePOIHelperAngle(angle: number){
    window.POIHelperAngle = angle;
    window.POIHelper.position = calculateSphereItemPosition({"coords":{"angle":window.POIHelperAngle, "height":window.POIHelperHeight}});
}
function MovePOIHelperHeight(height: number){
    window.POIHelperHeight = height;
    window.POIHelper.position = calculateSphereItemPosition({"coords":{"angle":window.POIHelperAngle, "height":window.POIHelperHeight}});
}

export default function SceneComponent(props: any) {
    const reactCanvas = useRef(null);
    const [onViewChange, setOnViewChange] = useState(0);
    const { antialias, engineOptions, adaptToDeviceRatio, sceneOptions, onRender, onSceneReady, data360, ...rest } = props;
    var scene: BABYLON.Scene;

    var photodome: BABYLON.PhotoDome;
    var meshList: BABYLON.Mesh[] = [];
    var meshListPoi: BABYLON.Mesh[] = [];

    const queryParams = querystring.parse(window.location.search);
    console.log(queryParams);
    const currentRoomName = queryParams.room;
    const currentRoomInfos = navItems.find((el)=>{return el.name == currentRoomName;});
    //currentRoomInfos!.img

    var tmpData = currentRoomInfos;
    var tmpData1 = currentRoomInfos;
    console.log(currentRoomInfos);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const changeSpheres = function () {
        if (!scene)
            return false;
        meshList.forEach(x => (x.dispose()));

        meshList = [];
        // TODO merge it with POI creation a bit further in the code
        tmpData!.directLinks.map((item: any) => {

            var disc = BABYLON.MeshBuilder.CreateDisc(item.name + "border_disc", { radius: AppConstants.POI_SPHERE_DIAMATER*0.6, tessellation: 48 } ,scene);
            var _materialDisc = new BABYLON.StandardMaterial(item.name + " materialdisc", scene);
            //      var _texture = new BABYLON.Texture(item.img, scene, false, false);
            
            // var _textureDisc = new BABYLON.Texture(borderImg, scene, false, false);
            // _textureDisc.hasAlpha = true;
            // _materialDisc.useAlphaFromDiffuseTexture = true;
            
            // _materialDisc.diffuseTexture = _textureDisc;
            _materialDisc.emissiveColor = new BABYLON.Color3(1.0, 1.0, 1.0);
            disc.material = _materialDisc;
            
            // Chargement des spheres pour cliquer sur les liens directs (e.g: Acceuil 1 > Accueil 2)
            var sphere = BABYLON.MeshBuilder.CreateSphere(item.name, { diameter: AppConstants.POI_SPHERE_DIAMATER }, scene);
            
            disc.position = sphere.position = calculateSphereItemPosition(item);
            disc.lookAt(Vector3.Zero());
            disc.rotate(BABYLON.Vector3.Up(), Math.PI);

            // Récuperation de l'objet entier de la liste "navItems" dans le placesInfo.js
            var fullItem: any = navItems.find((x) => (x.name === item.name));
            var _material = new BABYLON.StandardMaterial(item.name + " material", scene);
            var _texture = new BABYLON.Texture(fullItem.img, scene, false, false);

            _material.ambientTexture = _texture;
            _material.emissiveColor = new BABYLON.Color3(1, 1, 1);

            sphere.material = _material;
            // isPickable pour pouvoir récuperer le nom de la texture onClick

            sphere.isPickable = true;
            sphere.metadata = {type:"change",defaultOrientation: item.orientation};
            meshList.push(sphere);
            meshList.push(disc);
            
            return true;
        })
    }


    const changepoi = function () {
        if (!scene)
            return false;
        meshListPoi.forEach(x => (x.dispose()));
        meshListPoi = [];
        tmpData1!.poi.map((item: any) => {

            // Chargement des spheres pour cliquer sur les liens directs (e.g: Acceuil 1 > Accueil 2)
            //var sphere = BABYLON.MeshBuilder.CreateSphere(item.name, { diameter: AppConstants.POI_SPHERE_DIAMATER }, scene);
            var sphere = BABYLON.MeshBuilder.CreateDisc(item.name, { radius: AppConstants.POI_SPHERE_DIAMATER*.5, tessellation: 48 } ,scene);
            sphere.lookAt(Vector3.Zero());
            sphere.position = calculateSphereItemPosition(item);

            // Récuperation de l'objet entier de la liste "navItems" dans le placesInfo.js
            var _material = new BABYLON.StandardMaterial(item.name + " material", scene);
            //      var _texture = new BABYLON.Texture(item.img, scene, false, false);

            var _texture = new BABYLON.Texture(poiImg, scene, false, false);
            _texture.hasAlpha = true;
            _material.useAlphaFromDiffuseTexture = true;

             _material.diffuseTexture = _texture;
             _material.emissiveColor = new BABYLON.Color3(1.0, 1.0, 1.0);
            //_material.emissiveColor = new BABYLON.Color3(1, 1, 1);

            sphere.material = _material;
            // isPickable pour pouvoir récuperer le nom de la texture onClick
            sphere.isPickable = true;

            sphere.metadata = {type:"poi"};
            meshListPoi.push(sphere);

            return true;
        })
    }


    useEffect(() => { // This useEffect is used to refresh the scene when we change the img360 (located in data360.img)

        const createScene = function (err: any) {
            if (reactCanvas.current) {

                var engine = new BABYLON.Engine(reactCanvas.current, antialias, engineOptions, true);
                BABYLON.Database.IDBStorageEnabled = true;
                //engine.setHardwareScalingLevel(0.5); // TODO meh

                if (currentscene)
                    currentscene.dispose();
                scene = new BABYLON.Scene(engine);
                // scene.debugLayer.show({embedMode: true}); // DEBUG
                currentscene = scene;

                const mobileCamera = new BABYLON.DeviceOrientationCamera('MobileCamera', BABYLON.Vector3.Zero(), scene);
                const camera = new BABYLON.ArcRotateCamera("Camera", 2, 2, 0, BABYLON.Vector3.Forward(), scene);
                mobileCamera.inputs.addDeviceOrientation();

                scene.activeCamera = (isMobile) ? mobileCamera : camera;

                currentscene = scene;



                // color transition between scene
                scene.clearColor = new BABYLON.Color4(0.0, 0.0, 0.0, 1.0);

                // set FOV 
                camera.fov = 0.8;

                camera.position = new BABYLON.Vector3(0, 0, 0);
                // Invert x and Y mouse axes 
                camera.angularSensibilityX *= -1.5;
                camera.angularSensibilityY *= -1.5;
                mobileCamera.angularSensibility *= -1;
                mobileCamera.enableHorizontalDragging();

                // This params desactive the zoom (lower <= radius <= upper.)
                camera.lowerRadiusLimit = 0;
                camera.upperRadiusLimit = 0;

                // set keyboard ()
                camera.keysLeft = [39];   //   <--
                camera.keysRight = [37];  //   -->
                camera.keysUp = [40];
                camera.keysDown = [38];

                //this params Limit X et Y 
                camera.upperBetaLimit = 2.5;
                camera.lowerBetaLimit = 0.5;

                const canvas = scene.getEngine().getRenderingCanvas();
                if (scene.isReady()) {
                    // { // HELP DEBUG
                    //     window.Camera = camera;
                    //     window.POIHelperAngle = window.POIHelperHeight = 0;
                    //     var sphere = BABYLON.MeshBuilder.CreateSphere("POIHelper", { diameter: AppConstants.POI_SPHERE_DIAMATER }, scene);
                    //     sphere.position = calculateSphereItemPosition({"coords":{"angle":window.POIHelperAngle, "height":window.POIHelperHeight}});
                    //     window.POIHelper = sphere;
                    //     (window as any).MovePOIHelperAngle = MovePOIHelperAngle;
                    //     (window as any).MovePOIHelperHeight = MovePOIHelperHeight;
                    // }
                    const queryParams = querystring.parse(window.location.search);
                    console.log(queryParams);
                    const currentRoomName = queryParams.room;
                    const currentRoomInfos = navItems.find((el)=>{return el.name == currentRoomName;});
                    //currentRoomInfos!.img
                    console.log("currentImgURL" + tmpData!.img);
                    photodome = new BABYLON.PhotoDome("image360", tmpData!.img, {
                        size: 1000
                    }, scene);

                    if (isMobile) {
                        mobileCamera.attachControl(canvas, true);
                    }
                    else
                        camera.attachControl(canvas, true);
                        
                    changeSpheres();
                    changepoi();

                     // This needs to be done after instantiating POIs else, there's an offset in the calculation
                    camera.alpha = currentRoomInfos!.defaultOrientation;

                    var _prevPickedMesh: any = "";
                    scene.onPointerObservable.add((pointerInfo) => {
                        switch (pointerInfo.type) {
                            case BABYLON.PointerEventTypes.POINTERTAP:
                                var pickResult = pointerInfo.pickInfo;
                                if (pickResult?.hit) {
                                    var pickedMesh: any = pickResult.pickedMesh;

                                    if (_prevPickedMesh === pickedMesh?.name) return;
                                    _prevPickedMesh = pickedMesh?.name;

                                    if (pickedMesh && pickedMesh.metadata !== null) {
                                        
                                        if (pickedMesh.metadata.type === 'poi') {
                                            handleClickOpen();
                                        }
                                        else if (pickedMesh.metadata.type === 'change') {
                                            photodome.photoTexture = new BABYLON.Texture(pickedMesh.material.ambientTexture.name, scene, false, false);
                                            console.log("orientation " + pickedMesh.metadata.defaultOrientation);
                                            camera.alpha = pickedMesh.metadata.defaultOrientation;
                                            camera.beta = Math.PI/2.0; // To look forward

                                            // Changement de l'objet pour récupérer les spheres en fonction de la scene actuelle

                                            tmpData = navItems.find((x) => x.name === pickedMesh?.name);

                                            // Pour trigger le useEffect et appeller la methode "changeSphere"
                                            changepoi();
                                            changeSpheres();
                                        }
                                    }
                                }
                                break;
                            case BABYLON.PointerEventTypes.POINTERPICK:
                                break;
                        }
                    })

                } else {
                    scene.onReadyObservable.addOnce(scene => props.onSceneReady(scene));
                }
                engine.runRenderLoop(() => {
                    onRender(scene);
                    scene.render();
                })
                const resize = () => {
                    scene.getEngine().resize();
                }
                if (window) {
                    window.addEventListener('resize', resize);
                }

                return () => {
                    // cleanup
                    if (window) {
                        window.removeEventListener('resize', resize);
                    }
                }
            }
        };
        createScene(null);

    }, [reactCanvas, data360.img]);

    return (
        <div>
            <CustomizedDialogs open={open} close={handleClose} ></CustomizedDialogs>
            <div className='bg-black h-full w-full absolute left-0'></div>
            <canvas ref={reactCanvas} {...rest} touch-action="none" />
            <div id='default360Buttons'>
                <div className="h-12.5 flex absolute top-0 left-0 z-10" id='goBackBtn'>

                </div>
                {/* We hide it by default to avoid seeing it on android chrome before disabling it */}

            </div>


        </div>
    );

}